import axios from '@/utils/request';


// 登录
export const login = (params) => {
  return axios.post('/dataScreen/auth/login', {
    ...params,
  });
};
// 图形验证码
export const captcha = () => {
  return axios.post('/dataScreen/captcha/get');
};
// 短信验证码
export const smssend = (data) => {
  return axios.post('/dataScreen/sms/send',data);
};
// 账号登录
export const authlogin = (data) => {
  return axios.post('/dataScreen/auth/login',data);
};
// 短信登录
export const authsmsLogin = (data) => {
  return axios.post('/dataScreen/auth/smsLogin',data);
};
// 重置密码
export const authresetPasswordBySms = (data) => {
  return axios.post('/dataScreen/auth/resetPasswordBySms',data);
};

